import countries from 'i18n-iso-countries'
import enLocale from 'i18n-iso-countries/langs/en.json'

countries.registerLocale(enLocale)

const embargoedCountriesCodes = ['KP', 'IR', 'CU', 'SY', 'LB']

export const Countries = Object.entries(countries.getNames('en', { select: 'alias' }))
  .filter(([key]) => !embargoedCountriesCodes.includes(key))
  .map(([key, value]) => {
    if (key === 'UA') {
      return {
        label: 'Ukraine (other than Crimea, Donetsk or Luhansk)',
        value: key,
      }
    }
    return {
      label: value,
      value: key,
    }
  })
